import { Pipe, PipeTransform } from '@angular/core';

import { LicensePlan } from '../models/license-plan';

@Pipe({
    name: 'formatLicensePlans',
    standalone: false
})
export class FormatLicensePlansPipe implements PipeTransform {
	transform(licensePlans: LicensePlan[]): string {
		return licensePlans
			? licensePlans
					.filter(l => l.name.includes('Business Full') || ['Business Lite'].includes(l.name))
					.map(l => l.name)
					.join(', ')
			: '';
	}
}
